import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import * as $ from 'jquery';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

    constructor() {}

    ngOnInit() {
	}

}


// WEBPACK FOOTER //
// ./src/app/home/home.component.ts